import gql from 'graphql-tag';
import { graphql } from 'react-apollo';

export const POPULATED_SPECIALTIES = gql`
    query getPopulatedSpecialties($directoryId: String) {
        populatedSpecialties(directoryId: $directoryId) {
            id
            name
            numberOfProviders
        }
    }
`;

export const withPopulatedSpecialties = graphql(POPULATED_SPECIALTIES, {
    notifyOnNetworkStatusChange: true,
    options: ({ directoryId }) => ({
        ssr: true,
        variables: { directoryId },
    }),
    skip: ({ directoryId }) => !directoryId,
    props: ({ data }) => {
        if (data.loading) {
            return { loadingPopulatedSpecialties: true };
        } else if (data.error) {
            return;
        }

        return { populatedSpecialties: data.populatedSpecialties };
    },
});
